import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular';
import { AppUpdateService } from '../core/app-update.service';

/** Offers a reload once a new version of the app has been deployed. */
@Component({
    selector: 'app-update-banner',
    template: `
        @if (updates.updateAvailable()) {
            <div class="update-banner" role="status">
                <span>A new version is available.</span>
                <dx-button text="Reload" type="default" (onClick)="updates.reload()"></dx-button>
            </div>
        }
    `,
    styles: [
        `
            .update-banner {
                position: fixed;
                left: 50%;
                bottom: 16px;
                transform: translateX(-50%);
                z-index: 2000;
                display: flex;
                align-items: center;
                gap: 16px;
                max-width: calc(100vw - 32px);
                padding: 8px 8px 8px 16px;
                border: 1px solid #ddd;
                border-radius: 8px;
                background-color: #fff;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DxButtonModule],
})
export class UpdateBannerComponent {
    updates = inject(AppUpdateService);
}
